/**
 * **`Q`** tile plus wordmark for app chrome (**`ux/home-page`**).
 *
 * @param wordmark - Visible product label (**`quiz.home.header_title`**).
 */
export function buildHomeBrandCluster(wordmark: string): DocumentFragment {
  const frag = document.createDocumentFragment();
  const mark = document.createElement("span");
  mark.className = "home-brand__mark";
  mark.setAttribute("aria-hidden", "true");
  const letter = document.createElement("span");
  letter.className = "home-brand__mark-letter";
  letter.textContent = "Q";
  mark.appendChild(letter);

  const word = document.createElement("span");
  word.className = "home-brand__wordmark";
  word.textContent = wordmark;

  frag.append(mark, word);
  return frag;
}
